/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2PrintIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2PrintIcon({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2PrintIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 16,
  height = 16,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#000"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2PrintIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 16 16"
 style={{'--as-1-pPGff': alignSelf,'--mt-2-pPGff': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-pPGff': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-pPGff': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-pPGff': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-pPGff': opacity,'--w-10-pPGff': typeof width === 'number' ? `${width}px` : width,'--h-11-pPGff': typeof height === 'number' ? `${height}px` : height,'--f-12-pPGff': fill,'--a-7-pPGff': isAnimated ? animation : "none",'--sd-8-pPGff': isAnimated ? strokeDashoffset : 0,'--sd-9-pPGff': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<g
  data-testid="Tysiav2PrintIcon.SvgGroup"
  data-view-path={viewPath}
 clipPath="url(#clip0_2148_13850)"
 className="views-block"
>
<path
  data-testid="Tysiav2PrintIcon.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M4.786 2.429V4.57h6.428V2.43A.429.429 0 0010.786 2H5.214a.429.429 0 00-.428.429zm.546 7.714v3c0 .114.04.223.112.303a.36.36 0 00.27.125h4.573a.36.36 0 00.269-.125.457.457 0 00.112-.303v-3H5.332zM2.386 6.118c.243-.229.567-.352.9-.352h9.428c.333 0 .657.123.9.352.244.229.386.545.386.881v3.624c0 .337-.142.653-.386.882a1.315 1.315 0 01-.9.352h-.975v-1.714c0-.592-.48-1.072-1.071-1.072H5.332c-.591 0-1.071.48-1.071 1.072v1.714h-.975c-.333 0-.657-.124-.9-.352A1.21 1.21 0 012 10.623V7c0-.336.142-.652.386-.881zm7.598 1.237c0-.296.24-.535.536-.535h1.403a.536.536 0 110 1.071H10.52a.536.536 0 01-.536-.536z"
 style={{'--f-12-pPGff': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</g>
</svg>
{children}
</React.Fragment>)
}